import React, { useState, useContext } from 'react';
import { Bell, Shield, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import DailySignalSettings from '../components/DailySignalSettings';
import AdminNotificationConsole from '../components/AdminNotificationConsole';

const NotificationsPage = () => {
  const { user, hasRole } = useContext(AuthContext);
  const navigate = useNavigate();
  const [activeView, setActiveView] = useState('user'); // 'user' or 'admin'
  
  const isAdmin = hasRole('sysadmin', 'pmo_power');

  return (
    <div className="min-h-screen bg-[var(--clr-surface-page)] p-6">
      <div className="max-w-5xl mx-auto space-y-6">
        {/* Back Button */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-[var(--clr-text-muted)] hover:text-[var(--clr-text-primary)] transition"
          data-testid="back-btn"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </button>

        {/* Page Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[var(--clr-brand-primary)] to-[var(--clr-brand-primary-hover)] flex items-center justify-center shadow-lg">
              <Bell className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-[var(--clr-text-primary)]">Notifications</h1>
              <p className="text-[var(--clr-text-muted)]">
                Manage your Daily Signal™ preferences
              </p>
            </div>
          </div>

          {/* View Toggle (Admin Only) */}
          {isAdmin && (
            <div className="flex items-center bg-[var(--clr-surface-card)] rounded-lg border border-[var(--clr-border-light)] p-1">
              <button
                onClick={() => setActiveView('user')}
                className={`flex items-center gap-2 px-4 py-2 rounded-md transition ${
                  activeView === 'user'
                    ? 'bg-[var(--clr-brand-primary)] text-white'
                    : 'text-[var(--clr-text-secondary)] hover:text-[var(--clr-text-primary)]'
                }`}
                data-testid="view-user"
              >
                <Bell className="w-4 h-4" />
                My Settings
              </button>
              <button
                onClick={() => setActiveView('admin')}
                className={`flex items-center gap-2 px-4 py-2 rounded-md transition ${
                  activeView === 'admin'
                    ? 'bg-[var(--clr-brand-primary)] text-white'
                    : 'text-[var(--clr-text-secondary)] hover:text-[var(--clr-text-primary)]'
                }`}
                data-testid="view-admin"
              >
                <Shield className="w-4 h-4" />
                Admin Console
              </button>
            </div>
          )}
        </div>

        {/* Content */}
        <div className="bg-[var(--clr-surface-card)] rounded-xl border border-[var(--clr-border-light)] shadow-[var(--shadow-card)] p-6">
          {activeView === 'user' ? (
            <DailySignalSettings />
          ) : (
            <AdminNotificationConsole />
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationsPage;
